import { FETCH_CONTENT_LANDING, FETCH_LANDING_BANNERS } from '../types';


const initialState = {
  landing: null,
  landingBanners: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTENT_LANDING:
      return { ...state, landing: action.payload }
    case FETCH_LANDING_BANNERS:
      return { ...state, landingBanners: action.payload }
    default:
      return state;
  }
}

